import type { FilesAttachmentSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

import type { CommentAttachmentTileItem } from '../comment_attachment_tiles/comment_attachment_tiles';

export function getAttachmentTileItem(
  attachment: FilesAttachmentSchemaWithIdNullable,
): CommentAttachmentTileItem {
  return {
    id: attachment.id,
    name: attachment.name ?? attachment.filename ?? 'Attachment',
    url: attachment.url,
  };
}
